import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import ToastComponent from "../Common/TaostComponent";
import CommonService from "../../services/common.service";
import { useSelector, useDispatch } from "react-redux";
import { playerProfile } from "../../Slice/PlayerProfileSlice";
const ClaimPlayerProfileModal = (props) => {
  const dispatch = useDispatch();
  const initialValues = {
    email: "",
  };
  const [loading, setLoading] = useState(false);
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email field is required."),
  });
  const playerId = props.playerId;
  const onSubmit = (formValue) => {
    setLoading(true);
    formValue.playerId = props.playerId;
    CommonService.requestClaimPlayerProfile(formValue).then((res) => {
      if (res.status === 401) {
        ToastComponent(res.message, "error");
        setLoading(false);
      }
      if (res.status === 200) {
        ToastComponent(res.message, "success");
        props.setShowClaimProfile(false);
        setLoading(false);
        dispatch(playerProfile({ playerId }));
      }
    });
  };
  return (
    <Modal
      show={props.showClaimProfile}
      onHide={() => props.setShowClaimProfile(false)}
      id="playermoreinfo"
      size="lg"
    >
      <Modal.Header>Claim Player Profile</Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ errors, handleChange, values, touched, setFieldValue }) => (
            <Form>
              <div className="form-group">
                <Field
                  name="email"
                  type="text"
                  placeholder="Email"
                  className="form-control"
                />
                {touched.email && errors.email && (
                  <span className="help-inline error">{errors.email}</span>
                )}
              </div>
              <div className="text-left mt-3">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <div className="poweredby">
          Powered By
          <img src="/images/logo.png" alt="img" />
        </div>
        <div className="">
          <Link
            className="border-btn"
            onClick={() => props.setShowClaimProfile(false)}
          >
            Close
          </Link>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ClaimPlayerProfileModal;
